// extracted by mini-css-extract-plugin
export default {"currency":"cOWBpVLzU","oldPrice":"cVwmvFcKp","selectedValueContainer":"cQcffIXrl","anchorContainer":"cUOg_p841","icon":"ci2yNBdjJ"};